function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#FF4081",
  d: "M21.6 18.6c0 1.657-1.343 3-3 3H3c-1.657 0-3-1.343-3-3V3c0-1.657 1.343-3 3-3h15.6c1.657 0 3 1.343 3 3v15.6z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M16.237 12.164c-.422-.133-.879.105-1.012.537-.494 1.595-1.39 3.251-1.796 3.342-.304 0-.741-.258-1.175-.864 1.005-2.157 1.531-4.864 1.531-6.671 0-5.048-1.274-6.108-2.345-6.108-2.254 0-2.28 5.947-2.28 6.007 0 .7.025 1.349.073 1.954-.311-.114-.668-.192-1.062-.192-2.316 0-3.371 2.286-3.371 4.409 0 2 1.123 4.022 3.628 4.022 1.183 0 2.18-.775 2.985-1.933.712.741 1.459 1.018 2.016 1.018 1.753 0 2.914-3.14 3.333-4.492.134-.431-.102-.892-.525-1.03zm-7.808 4.794c-1.819 0-2.016-1.665-2.016-2.381 0-.113.02-2.767 1.759-2.767.686 0 1.213.531 1.213.531.04.042.082.079.127.11.225 1.143.543 2.056.91 2.78-.602 1.043-1.3 1.727-1.993 1.727zm2.912-3.802c-.336-1.158-.568-2.713-.568-4.749 0-1.875.4-3.64.731-4.244.255.387.67 1.59.67 4.345 0 1.462-.324 3.16-.833 4.648z"
}));

var SvgIconDribbble = function SvgIconDribbble(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconDribbble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-dribbble.5bde6320.svg";
export { ForwardRef as ReactComponent };